import React, {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {
  HistoryComponent,
  HistoryComponentProps,
} from 'src/components/elements/account/newHistoryUI/historyComponent';

const AdjustmentHistoryList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.adjustment;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'LoyaltyCreditHistoryList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return <HistoryComponent historyfilter={filterTypes.adjustment} {...props} />;
};

export default AdjustmentHistoryList;
